import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";

const SmokeTestResults = ({ data, isSuccess }) => {

  let runs = [];

  if (data && data.length > 0) {

    const runMap = new Map();

    data.forEach(row => {
      row.runs?.forEach(run => {

        const runId = run.run;

        if (!runMap.has(runId)) {

          const device = Object.keys(run).find(k => k !== "run");

          runMap.set(runId, {
            runId,
            device
          });

        }

      });
    });

    runs = Array.from(runMap.values()).sort((a, b) => a.runId - b.runId);

  }

  const filteredData = data?.filter(row => row.milestone !== null) || [];

  return (

    <Box pt={2}>

      {isSuccess && filteredData.length > 0 && (

        <Table>

          <TableHead>

            <TableRow>

              <TableCell>
                <b>Milestone</b>
              </TableCell>

              {runs.map((run, i) => (

                <TableCell
                  key={run.runId}
                  align="center"
                >
                  <b>{run.device} Run {i + 1}</b>
                </TableCell>

              ))}

            </TableRow>

          </TableHead>

          <TableBody>

            {filteredData.map((row) => (

              <TableRow key={row.milestone}>

                <TableCell>
                  {row.milestone}
                </TableCell>

                {runs.map(run => {

                  const matchingRun =
                    row.runs?.find(r => r.run === run.runId);

                  const device = run.device;

                  const status =
                    matchingRun ? matchingRun[device] : null;

                  return (

                    <TableCell
                      key={`${row.milestone}-${run.runId}`}
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        color:
                          status === "PASS"
                            ? "green"
                            : status === "FAIL"
                            ? "red"
                            : "inherit",
                      }}
                    >
                      {status || "-"}
                    </TableCell>

                  );

                })}

              </TableRow>

            ))}

          </TableBody>

        </Table>

      )}

    </Box>

  );

};

export default SmokeTestResults;